import React, { useCallback, useEffect } from 'react'
import { useWeb3React } from '@web3-react/core'
import styled from 'styled-components'
import {
  Flex,
  LogoutIcon,
  useModal,
  UserMenu as UIKitUserMenu,
  UserMenuDivider,
  UserMenuItem,
  Button,
  Text,
  ConnectorNames,
} from 'vvs-uikit'
import useAuth from 'hooks/useAuth'
import { useConnectionError } from 'state/user/hooks'
// import { useProfile } from 'state/profile/hooks'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { FetchStatus, useGetCroBalance } from 'hooks/useTokenBalance'
import { useTranslation } from 'contexts/Localization'
import WalletModal, { WalletView, LOW_CRO_BALANCE } from './WalletModal'
// import ProfileUserMenuItem from './ProfileUserMenutItem'
import WalletUserMenuItem from './WalletUserMenuItem'
import SwitchNetworkModal from './SwitchNetworkModal'

const StyledButton = styled(Button)`
  background: white;
`

const StyledIcon = styled('div')`
  height: 34px;
  width: 34px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  background: ${({ theme }) => theme.colors.failure};
`

const UserMenu = () => {
  const { t } = useTranslation()
  const web3 = useWeb3React()
  const { logout } = useAuth()
  const { balance, fetchStatus } = useGetCroBalance()
  // const { isInitialized, isLoading, profile } = useProfile()
  const [onPresentWalletModal] = useModal(<WalletModal initialView={WalletView.WALLET_INFO} />)
  const [onPresentTransactionModal] = useModal(<WalletModal initialView={WalletView.TRANSACTIONS} />)
  const [onSwitchNetworkModal] = useModal(<SwitchNetworkModal />)

  // const hasProfile = isInitialized && !!profile
  // const avatarSrc = profile && profile.nft ? `/images/nfts/${profile.nft.images.sm}` : undefined
  const [connectionError, setConnectionError] = useConnectionError()
  const onNetworkClick = useCallback(() => {
    if (
      connectionError &&
      (connectionError.connectorID === ConnectorNames.Metamask ||
        connectionError.connectorID === ConnectorNames.Injected)
    ) {
      onSwitchNetworkModal()
    }
  }, [connectionError, onSwitchNetworkModal])
  const hasLowCroBalance = fetchStatus === FetchStatus.SUCCESS && balance.lte(LOW_CRO_BALANCE)

  // web3 instance changes when the wallet is successfully connected again to the correct network.
  useEffect(() => {
    if (web3.active) {
      setConnectionError(null)
    }
  }, [web3, setConnectionError])

  if (connectionError) {
    return (
      <StyledButton roundness="lg" height="42px" onClick={onNetworkClick} pl="4px" pr="12px">
        <StyledIcon>!</StyledIcon>
        <Text fontSize="14px" textAlign="center" color="failure" mb="4px" ml="12px" bold>
          {t('Wrong Network')}
        </Text>
      </StyledButton>
    )
  }

  if (!web3.account) {
    return (
      <ConnectWalletButton roundness="lg" borderRadius="50px" height="42px" padding="12px 24px 12px 24px" scale="xs" />
    )
  }

  return (
    // <UIKitUserMenu account={account} avatarSrc={avatarSrc}>
    <UIKitUserMenu account={web3.account}>
      <WalletUserMenuItem hasLowCroBalance={hasLowCroBalance} onPresentWalletModal={onPresentWalletModal} />
      <UserMenuItem as="button" onClick={onPresentTransactionModal}>
        {t('Transactions')}
      </UserMenuItem>
      <UserMenuDivider />
      {/* <ProfileUserMenuItem isLoading={isLoading} hasProfile={hasProfile} />
      <UserMenuDivider /> */}
      <UserMenuItem as="button" onClick={logout}>
        <Flex alignItems="center" justifyContent="space-between" width="100%">
          {t('Disconnect')}
          <LogoutIcon />
        </Flex>
      </UserMenuItem>
    </UIKitUserMenu>
  )
}

export default UserMenu
